<template>
  <div>
    <PageAllow controller="Registers" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherKeyword
                v-model="options.name"
                @text="nameKeyWord = $event"
                :label="$t('Registers.name')"
              />
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("Export.batchExport") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    v-model="options.tel"
                    @text="titleKeyWord = $event"
                    :label="$t('Registers.tel')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('Registers.status.title')"
                    :items="$consts.shopMade"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="registers"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:item.created="{ item }">
            {{ item.created | formatDate }}
          </template>
          <template v-slot:item.shop_made="{ item, index }">
            <span :v-resize="!index ? $stickTableResizer() : null"> </span>
            <v-chip
              small
              label
              :color="item.shop_made | shopMadeColor"
              :text-color="item.shop_made | shopMadeTextColor"
            >
              {{ item.shop_made | shopMadeText }}
            </v-chip>
          </template>
          <template v-slot:item.recommend_name="{ item }">
            <span v-if="item.recommend_name">
              {{ item.recommend_name }} / {{ item.recommend_code }}(
              <span v-if="!item.recommend_agent_id">
                {{ $consts.allianceName() }}
              </span>
              <span v-else-if="!item.recommend_shop_id">
                {{ $consts.shopName() }} </span
              >)
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- 删除 -->
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('Registers', 'delete') &&
                !item.shop_made
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="accent"
                  class="px-2 me-2 mb-1"
                  @click.stop="del(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Registers.delete") }}
                </v-btn>
              </template>
              <span>{{ $t("Registers.delete") }}</span>
            </v-tooltip>
            <!-- 生成门店 -->
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('Registers', 'makeAddShop') &&
                !item.shop_made
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="getRegisterFromAPI(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Registers.makeAddShop", [$consts.shopName()]) }}
                </v-btn>
              </template>
              <span>{{
                $t("Registers.makeAddShop", [$consts.shopName()])
              }}</span>
            </v-tooltip>
            <!-- 备注详情 -->
            <v-tooltip
              top
              v-if="$permission.permissionAllow('Registers', 'view')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    detailDialog = true;
                    itemComment = item.comment;
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Registers.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("Registers.detail") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <v-dialog v-model="detailDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("Registers.detail") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="detailDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ itemComment }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="detailDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addShopDialog" width="680px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("Registers.makeAddShop", [$consts.shopName()]) }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="addShopDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center">
          <ValidationObserver ref="observer">
            <!-- 客户编号 -->
            <v-row
              align="center"
              v-if="
                !(settings
                && settings.push_platform_setting
                && settings.push_platform_setting[2101]
                && settings.push_platform_setting[2101]['sync_shop_data_from'] == 2)
              "
              >
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("Registers.Fields.shop_code", [$consts.shopName()]) +
                  $t("Global.colon")
                }}
                <Required :show="true" mode="edit" />
              </v-col>
              <v-col cols="9" md="7">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Registers.Fields.shop_code', [$consts.shopName()])"
                  rules="required"
                >
                  <v-text-field
                    single-line
                    v-model="register.shop_code"
                    :error-messages="errors"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- 客户名称 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("Registers.Fields.shop_name", [$consts.shopName()]) +
                  $t("Global.colon")
                }}
                <Required :show="true" mode="edit" />
              </v-col>
              <v-col cols="9" md="7">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Registers.Fields.shop_name', [$consts.shopName()])"
                  rules="required"
                >
                  <v-text-field
                    single-line
                    v-model="register.name"
                    :error-messages="errors"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- 客户类型 -->
            <v-row
              align="center"
              v-if="
                settings &&
                settings.kingdee_shop_types &&
                Object.keys(settings.kingdee_shop_types).length
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("Registers.Fields.shop_type", [$consts.shopName()]) +
                  $t("Global.colon")
                }}
                <Required :show="true" mode="edit" />
              </v-col>
              <v-col cols="9" md="7">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Registers.Fields.shop_type', [$consts.shopName()])"
                  rules="required"
                >
                  <v-select
                    v-model="register.shop_types"
                    :items="kingdeeShopTypes"
                    item-value="code"
                    item-text="text"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- 分组 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("Registers.Fields.shop_district") + $t("Global.colon") }}
                <Required :show="true" mode="edit" />
              </v-col>
              <v-col cols="9" md="7">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Registers.Fields.shop_district')"
                  rules="required"
                >
                  <SearcherDistrict
                    v-model="district"
                    no-label
                    unclearable
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- 地区 -->
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("Registers.Fields.shop_address", [$consts.shopName()]) +
                  $t("Global.colon")
                }}
                <Required :show="true" mode="edit" />
              </v-col>
              <v-col cols="9" md="7">
                <!-- 三级地址 -->
                <CitiesSelectGroup
                  :masterItem="masterItem"
                  @provinceSelected="register.province = $event.id"
                  @citySelected="register.city = $event.id"
                  @districtSelected="register.area = $event.id"
                />
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="
                    $t('Registers.Fields.shop_address', [$consts.shopName()])
                  "
                  rules="required"
                >
                  <v-text-field
                    single-line
                    v-model="register.address"
                    :label="
                      $t('Registers.Fields.shop_address', [$consts.shopName()])
                    "
                    :error-messages="errors"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- 要货模板 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("Registers.Fields.template") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <SearcherTemplate v-model="template" unclearable no-label />
              </v-col>
            </v-row>
            <!-- 状态 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("Registers.Fields.shop_status") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="status">
                  <v-radio
                    v-for="statu in shopStatus"
                    :key="statu.value"
                    :label="`${statu.text}`"
                    :value="statu.value"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- 备注详情 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("Registers.Fields.memo") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-textarea outlined v-model="register.comment"></v-textarea>
              </v-col>
            </v-row>
            <!-- 负责人 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("Registers.Fields.shop_user_name") + $t("Global.colon") }}
                <Required :show="true" mode="edit" />
              </v-col>
              <v-col cols="9" md="7">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Registers.Fields.shop_user_name')"
                  rules="required"
                >
                  <v-text-field
                    single-line
                    v-model="register.shop_user.name"
                    :error-messages="errors"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- 身份证号 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("Registers.Fields.identification_num") + $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="identification_num"
                  single-line
                  :placeholder="$t('Registers.Fields.num')"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 联系方式 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("Registers.Fields.shop_user_tel") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field v-model="register.tel" single-line>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 登录ID -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("Registers.Fields.login_user_id") + $t("Global.colon") }}
                <Required :show="true" mode="edit" />
              </v-col>
              <v-col cols="9" md="7">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Registers.Fields.login_user_id')"
                  rules="required|min:6"
                >
                  <v-text-field
                    single-line
                    v-model="register.shop_user.login_user_id"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- 登录密码 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("Registers.Fields.login_user_password") +
                  $t("Global.colon")
                }}
                <Required :show="true" mode="edit" />
              </v-col>
              <v-col cols="9" md="7">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Registers.Fields.login_user_password')"
                  rules="required|min:6"
                >
                  <v-text-field
                    single-line
                    v-model="register.shop_user.password"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" outlined @click="addShopDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" @click="submit()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import Registers from "@/api/registers";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherTemplate from "@/components/plugins/SearcherTemplate";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import CitiesSelectGroup from "@/components/plugins/CitiesSelects";
import Consts from "@/consts.js";

const defaultOptions = {
  tel: "",
  status: [0, 1],
  name: "",
};

export default {
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    registers: [],
    detailDialog: false,
    itemComment: "",
    register: {},
    addShopDialog: false,
    masterItem: {},
    template: { id: "0" },
    status: 1,
    district: null,
    identification_num: "",
  }),

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopManagement", [this.$consts.shopName()]),
          disabled: false,
          href: "/shops",
        },
        {
          text: i18n.t("Nav.registers"),
          disabled: true,
          href: "/registers",
        },
      ];
    },

    headers() {
      return [
        {
          text: i18n.t("Registers.Fields.name"),
          align: "start",
          class: "text-no-wrap",
          width: "100",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("Registers.Fields.tel"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "tel",
        },
        {
          text: i18n.t("Registers.Fields.address"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "address",
        },
        {
          text: i18n.t("Registers.Fields.comment"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "comment",
        },
        {
          text: i18n.t("Registers.Fields.created"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("Registers.Fields.status"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_made",
        },
        {
          text: i18n.t("Registers.Fields.recommend_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "recommend_name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "actions",
        },
      ];
    },
    shopStatus() {
      return Consts.shop.status;
    },
    kingdeeShopTypes() {
      let arr = [];
      if (
        this.settings &&
        this.settings.kingdee_shop_types &&
        Object.keys(this.settings.kingdee_shop_types).length
      ) {
        Object.keys(this.settings.kingdee_shop_types).forEach((type) => {
          arr.push({
            code: type,
            text: i18n.t("Registers.Fields.text", [
              type,
              this.settings.kingdee_shop_types[type],
            ]),
          });
        });
      }
      return arr;
    },

    ...mapState(["loading", "stickTableCols", "settings"]),
  },

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherStatus,
    Required,
    ValidationObserver,
    ValidationProvider,
    SearcherTemplate,
    SearcherDistrict,
    CitiesSelectGroup,
  },

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        name: this.nameKeyWord,
        tel: this.telKeyWord,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getRegistersFromAPI() {
      Registers.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.registers = response.data.registers;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    getRegisterFromAPI(id) {
      Registers.fetchOne(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.register = response.data.register;
            this.register = Object.assign({}, this.register, {
              shop_user: {
                name: this.register.name,
                login_user_id: this.register.tel,
                password: this.register.tel,
                tel: this.register.tel,
              },
            });
            this.masterItem = {
              province_id: this.register.province,
              city_id: this.register.city,
              area_id: this.register.area,
            };
            this.template = { id: "0" };
            this.status = 1;
            this.district = null;
            this.identification_num = "";
            this.addShopDialog = true;
          }
        }.bind(this)
      );
    },
    del(id) {
      Registers.del(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getRegistersFromAPI();
          }
        }.bind(this)
      );
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var shop_user = Object.assign({}, this.register.shop_user, {
              identification_num: this.identification_num,
            });
            var data = {
              shop_code: this.register.shop_code,
              shop_name: this.register.name,
              shop_types: this.register.shop_types,
              material_template_id: this.template.id,
              city_1: this.district.code,
              status: this.status,
              comment: this.register.comment,
              address: this.register.address,
              province_id: this.register.province,
              city_id: this.register.city,
              area_id: this.register.area,
              shop_user: shop_user,
            };
            Registers.save(this.register.id, data)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$refs.observer.reset();
                    this.addShopDialog = false;
                    this.getRegistersFromAPI();
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    exportExcel() {
      Registers.exports(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getRegistersFromAPI();
        sessionStorage.setItem(
          "registers-options",
          JSON.stringify(this.options)
        );
      },
    },
  },
};
</script>

<style>
</style>